<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information/transfer-agent-auditor',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs/agent-transfert-auditeur'
  }
})

useHead({
  title: t('navigation.transfertAgentAuditor.metatitle'),
  meta: [{ name: 'description', content: t('navigation.transfertAgentAuditor.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.transfertAgentAuditor.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.transfertAgentAuditor.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <h2>Transfer agent and registrar</h2>
            <p>TSX Trust Company</p>
            <p>
301 - 100 Adelaide Street West<br>Toronto, Ontario M5H 4H1<br>Telephone: <a name="hyperlien"
                 href="tel:1-866-393-4891"
                 target="_blank">1-866-393-4891</a><br>Local: <a href="tel:1-416-361-0930"
                 target="_blank">416-361-0930</a><br>Fax: 416-361-0470
</p>
            <p>
<a name="hyperlien"
                 onclick="ga('send', 'event', { eventCategory: 'Action section Investor Relations', eventAction: 'Transfert Agent and Auditor', eventLabel: 'TMXEInvestorServices@tmx.com'});"
                 href="mailto:TMXEInvestorServices@tmx.com">TMXEInvestorServices@tmx.com</a>
</p>
            <h2>Stock Exchange Listing</h2>
            <p>Toronto Stock Exchange<br>Stock Symbol "KPT"</p>
            <h2>Auditor</h2>
            <p>PricewaterhouseCoopers LLP<br>PwC Center, 354 Davis Road<br>Suite 600<br>Oakville ON L6J 0C5</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <h2>Agent des transferts et agent chargé de la tenue des registres</h2>
            <p>
TSX Trust Company<br>301 - 100 Adelaide Street West<br>Toronto (Ontario) M5H 4H1<br>Téléphone: <a href="tel:1-866-393-4891">1 866 393-4891</a><br>Ligne locale: <a href="tel:1-416-361-0930">416 361-0930</a><br>Téléc.: 416 361-0470<br><a name="hyperlien"
                 href="mailto:TMXEInvestorServices@tmx.com">TMXEInvestorServices@tmx.com</a>
</p>
            <h2>Inscription Boursière</h2>
            <p>La Bourse de Toronto<br>Symbole boursier « KPT »</p>
            <h2>Auditeur</h2>
            <p>PricewaterhouseCoopers LLP<br>PwC Centre, 354 Davis Road<br>Bureau 600<br>Oakville ON L6J 0C5</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
